import React, { useState, useEffect, useMemo, useCallback, useRef } from 'react';
import { useLocation, useHistory, Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withStyles, MuiThemeProvider, createTheme } from '@material-ui/core/styles';
import { withRoomContext } from '../../../RoomContext';
import {
	peersLengthSelector
} from '../../Selectors';
import * as settingsActions from '../../../actions/settingsActions';
import * as roomActions from '../../../actions/roomActions';
import * as meActions from '../../../actions/meActions';
import * as chatActions from '../../../actions/chatActions';
import DeviceSettings from '../Common/DeviceSettings';
import TextField from '@material-ui/core/TextField';
import classnames from 'classnames';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

import ConfirmDialog from '../Common/ConfirmDialog';

// Firebase
import { firestore } from '../../../lib/firebase';

// Daysjs
import dayjs from 'dayjs';
import weekday from 'dayjs/plugin/weekday';

dayjs.extend(weekday);

const styles = () =>
	({
		root :
		{
			width           : '100%',
			height          : '100%',
			position        : 'relative',
			display         : 'flex',
			overflow        : 'auto',
			backgroundColor : '#e5e5e2',
			aspectRatio     : 1.77
		},
		rootM :
		{
			overflow : 'auto'
		},
		mediaSettings :
		{
			width        : '38%',
			paddingRight : '1%'
		},
		mediaSettingsM :
		{
			width      : '100%',
			paddingTop : '3%'
		},
		roomJoin :
		{
			width         : '60%',
			display       : 'flex',
			flexDirection : 'column',
			paddingLeft   : '1%'
		},
		roomJoinM :
		{
			width         : '100%',
			display       : 'flex',
			flexDirection : 'column'
		},
		roomJoinMargin0 :
		{
			marginTop : '8%'
		},
		roomJoinMargin1 :
		{
			marginTop : '4%'
		},
		logo :
		{
			width     : 'auto',
			height    : 'auto',
			maxHeight : '10%',
			maxWidth  : '30%',
			margin    : '0 auto 5% auto'
		},
		description :
		{
			marginBottom : '3%',
			fontSize     : '1rem',
			color        : '#999898'
		},
		descriptionM :
		{
			marginBottom : '3%',
			fontSize     : '0.9rem',
			color        : '#999898',
			padding      : '0 10%'
		},
		input :
		{
			width          : '100%',
			display        : 'flex',
			justifyContent : 'start',
			alignItems     : 'center',
			marginBottom   : '1%'
		},
		inputCamera :
		{
			width          : '100%',
			display        : 'flex',
			justifyContent : 'start',
			alignItems     : 'center',
			marginBottom   : '1%',
			padding        : '4% 0 1% 0'
		},
		inputM :
		{
			width          : '100%',
			display        : 'flex',
			flexDirection  : 'column',
			justifyContent : 'center',
			alignItems     : 'center',
			marginBottom   : '1%',
			padding        : '2% 5%'
		},
		inputLabel :
		{
			minWidth : '25%',
			fontSize : '1rem',
			color    : '#999898'
		},
		inputLabelM :
		{
			height       : '1rem',
			width        : '100%',
			textAlign    : 'center',
			fontSize     : '1rem',
			color        : '#999898',
			marginBottom : '1%'
		},
		guestInputLabelM :
		{
			height       : '1rem',
			marginLeft   : '5%',
			width        : '95%',
			textAlign    : 'left',
			fontSize     : '1rem',
			color        : '#999898',
			marginBottom : '1%'
		},
		inputField :
		{
			width                       : '90%',
			'& .MuiOutlinedInput-input' :
			{
				borderRadius : '2rem'
			}
		},
		inputFieldInput :
		{
			width    : '100%',
			fontSize : '0.8rem'
		},
		cameraControl :
		{
			width          : '40%',
			display        : 'flex',
			justifyContent : 'center'
		},
		cameraSwitchBtn :
		{
			width           : '4rem',
			height          : '4rem',
			borderRadius    : '4rem',
			fontSize        : '0.8rem',
			backgroundColor : 'white',
			color           : '#adadac',
			boxShadow       : '2px 2px 4px #aaa',
			margin          : '0 3%',
			'&:hover'       :
				{
					backgroundColor : '#f50057'
				}
		},
		cameraSwitchBtnActive :
		{
			backgroundColor : '#9ec317',
			color           : 'white',
			boxShadow       : '2px 2px 4px inset #aaa'
		},
		separator :
		{
			borderBottom : '1px solid #ccc',
			margin       : '1% 2% 2% 2%'
		},
		terms :
		{
			marginTop    : '3%',
			marginBottom : '0.5%'
		},
		termsM :
		{
			marginTop    : '3%',
			marginBottom : '5%'
		},
		termsLabel :
		{
			width     : '100%',
			textAlign : 'center',
			fontSize  : '1rem',
			color     : '#999898'
		},
		termsBtnWrapper : {
			marginTop      : '10px',
			display        : 'flex',
			justifyContent : 'center'
		},
		termsBtn :
		{
			color           : '#999898',
			backgroundColor : 'white',
			boxShadow       : '2px 2px 4px #aaa',
			borderRadius    : '0.3rem',
			paddingLeft     : '1.2rem',
			whiteSpace      : 'nowrap'
		},
		termsBtnM :
		{
			color           : '#999898',
			backgroundColor : 'white',
			boxShadow       : '3px 3px 4px #aaa',
			borderRadius    : '0.3rem',
			padding         : '0.2rem 1.2rem 0.2rem 2.2rem',
			marginTop       : '4%',
			whiteSpace      : 'nowrap'
		},
		termsLink :
		{
			color          : '#999898',
			textDecoration : 'none'
		},
		termsIcon :
		{
			marginBottom : '1%'
		},
		startBtn :
		{
			width           : '70%',
			color           : 'white',
			backgroundColor : '#9ec317',
			boxShadow       : '2px 2px 4px #aaa',
			borderRadius    : '0.5rem',
			padding         : '1rem',
			margin          : '1.5% auto',
			fontSize        : '1.2rem'
		},
		startBtnM :
		{
			width           : '80%',
			color           : 'white',
			backgroundColor : '#9ec317',
			boxShadow       : '2px 2px 4px #aaa',
			borderRadius    : '0.35rem',
			padding         : '1rem',
			margin          : '2% 10%',
			fontSize        : '1rem'
		},
		warning :
		{
			marginTop   : '4%',
			color       : '#999898',
			fontSize    : '0.8rem',
			paddingLeft : '1rem'
		},
		warningM :
		{
			marginTop : '4%',
			color     : '#999898',
			fontSize  : '0.8rem',
			padding   : '0 10%'
		},
		warningLink : {
			color       : '#e26b04',
			marginRight : '0.3rem'
		},
		callingModal :
		{
			position        : 'fixed',
			width           : '100vw',
			height          : '100vh',
			display         : 'flex',
			backgroundColor : 'rgba(255,255,255,0.9)',
			flexDirection   : 'column',
			justifyContent  : 'center',
			alignItems      : 'center',
			textAlign       : 'center',
			top             : 0,
			left            : 0
		},
		toggleSettingsBtnM :
		{
			width           : '80%',
			color           : '#999898',
			backgroundColor : 'white',
			boxShadow       : '3px 3px 4px #aaa',
			borderRadius    : '0.3rem',
			padding         : '0.2rem 1.2rem 0.2rem 2.2rem',
			marginTop       : '4%',
			marginBottom    : '2%',
			marginLeft      : '10%',
			'&:hover'       :
			{
				backgroundColor : '#fff'
			}
		}
	});

const theme = createTheme({
	overrides : {
		PrivateNotchedOutline : {
			root : {
				borderRadius : '0.5rem',
				border       : 'none',
				boxShadow    : '2px 2px 4px inset #999898'
			}
		},
		MuiOutlinedInput : {
			input : {
				padding         : '0.3rem 0.5rem',
				border          : 'none',
				borderRadius    : '0.3rem',
				backgroundColor : '#999898',
				boxShadow       : '2px 2px 4px inset #999898',
				color           : 'white'
			},
			notchedOutline : {
				border : 'none'
			}
		}
	}
});

/**
 * Global Values
 */
const timer = null;

let retryCount = 0;

let roomIndex = 0;

const IDLE = 0;

const CONNECTING = 1;

const WAITING = 2;

const RETRY = 3;

const TALKING = 4;

const FAILED = 5;

const parts = window.location.hostname.split('.');

const subdomain = parts.shift();

const GuestJoinView = ({
	room,
	roomClient,
	classes,
	mediaPerms,
	videoMuted,
	setAudioMuted,
	setVideoMuted,
	rooms,
	settings,
	guestInput1,
	guestInput2,
	setGuestInput1,
	setGuestInput2,
	setLogoUrl,
	isMobile,
	chearChat,
	setVideoResolution,
	setVideoFrameRate,
	fetchRoomsComplete,
	setHideGuestButtomNavi,
	useMobileView,
	setUseMobileView
}) =>
{
	const location = useLocation();
	const history = useHistory();

	const [ connectionStatus, setConnectionStatus ] = useState(room.state === 'connecting' ? WAITING : IDLE);
	// OPEN/CLOSE TIME
	const [ userOpenTime, setUserOpenTime ] = useState('10:00');
	const [ userCloseTime, setUserCloseTime ] = useState('18:00');

	// guestInputField
	// GuestInput
	const [ guestInputField1, setGuestInputField1 ] = useState('');
	const [ guestInputField2, setGuestInputField2 ] = useState('');

	// Holiday
	const [ userHoliday, setUserHoliday ] = useState([ 0, 0, 0, 0, 0, 0, 0, 0 ]);

	// nationalHolidays 
	const [ nationalHolidays, setNationalHolidays ] = useState([]);

	// Device Setting Toggle
	const [ showDeviceSettings, setShowDeviceSettings ] = useState(false);

	const endOfcontentRef = useRef();

	const getStatusString = (state) =>
	{
		switch (state)
		{
			case 0: return 'IDLE';
			case 1: return 'CONNECTING';
			case 2: return 'WAITING';
			case 3: return 'RETRY';
			case 4: return 'TALKING';
			case 5: return 'FAILED';
			default: return 'UNKNOWN';
		}
	};

	const [ confirmDialogState, setConfirmDialogState ] = useState(
		{
			show    : false,
			title   : '',
			message : ''
		}
	);

	const closeConfirmDialog = (returnToLobby) =>
	{

		setConfirmDialogState(
			{
				show    : false,
				title   : '',
				message : ''
			}
		);

		if (returnToLobby === true)
		{
			history.replace({
				pathname : '/lobby',
				state    : { directMode: false }
			});
		}
	};

	const handleJoin = useCallback((arg) =>
	{
		// ルームIDの調整
		if (!rooms || rooms.length === 0)
		{

			// alert('申し訳ありません。ただいま混み合っておりますので、お時間が経ってから、アクセスしてください'); // eslint-disable-line no-alert

			setConfirmDialogState({
				show    : true,
				title   : '混雑しています',
				message : '申し訳ありません。ただいま混み合っておりますので、お時間が経ってから、アクセスしてください'
			});

			return;
		}

		//
		// select room to call
		//
		if (rooms.length === 1)
		{
			roomIndex = 0;
		}
		// static call (always start from smallest room No)
		else if (Number(settings.callPriority) === 2)
		{
			if (arg.retry === true)
			{
				if (roomIndex === rooms.length - 1)
				{
					roomIndex = 0;
				}
				else
				{
					roomIndex += 1;
				}
			}
			else
			{
				roomIndex = 0;
			}
		}
		else
		{
			// find last called operator
			let lastCalledRoomIndex = undefined;

			if (arg.retry === true)
			{
				lastCalledRoomIndex = roomIndex;
			}
			else
			{

				let maxLastCalledAt = 0;

				rooms.forEach((r, index) =>
				{
					if (r.lastCalledAt && r.lastCalledAt > maxLastCalledAt)
					{

						maxLastCalledAt = r.lastCalledAt;
						lastCalledRoomIndex = index;
					}
				});
			}

			// random call
			if (Number(settings.callPriority) === 1 && arg.retry !== true)
			{
				const candidateRooms = [ ...rooms ];

				// last call exist
				if (lastCalledRoomIndex !== undefined)
				{
					// remove previously called room
					candidateRooms.splice(lastCalledRoomIndex, 1);
				}

				const randomIndexInCandidate = Math.floor(Math.random() * candidateRooms.length);

				const randomRoomIndex =
					rooms.findIndex((r) => r.id === candidateRooms[randomIndexInCandidate].id);

				if (randomRoomIndex !== -1)
				{
					roomIndex = randomRoomIndex;
				}

			}
			// order call
			else if (lastCalledRoomIndex !== undefined
					&& lastCalledRoomIndex < rooms.length - 1)
			{
				roomIndex = lastCalledRoomIndex + 1;
			}
			else
			{
				roomIndex = 0;
			}
		}

		const encodedRoomId = encodeURIComponent(rooms[roomIndex].id);

		console.info(`handleJoin roomId=${rooms[roomIndex].id}`); // eslint-disable-line no-console

		chearChat();

		roomClient.join({
			roomId    : encodedRoomId,
			joinVideo : mediaPerms.video,
			joinAudio : mediaPerms.audio,
			subdomain : subdomain
		});

		setConnectionStatus(CONNECTING);

	}, [
		rooms,
		roomClient,
		mediaPerms.audio,
		mediaPerms.video,
		chearChat,
		settings.callPriority
	]);

	// 自己切断
	useEffect(() =>
	{

		console.info(`STATE CHANGED STATE=${getStatusString(connectionStatus)}, roomState=${room.state}, retry=${retryCount}/${settings.relayNum}, index=${roomIndex}, roomNum=${rooms.length}`); // eslint-disable-line no-console

		if (connectionStatus === CONNECTING)
		{
			if (room.state === 'connecting')
			{
				setConnectionStatus(WAITING);
			}
		}
		else if (connectionStatus === WAITING)
		{
			if (room.state === 'closed')
			{
				// リトライカウントの制御
				retryCount++;
				if (retryCount > rooms.length * settings.relayNum)
				{
					setConnectionStatus(FAILED);
				}
				else
				{
					setConnectionStatus(RETRY);
				}
			}
			else if (room.state === 'connected')
			{
				clearTimeout(timer);
				setConnectionStatus(TALKING);
			}
		}
		else if (connectionStatus === RETRY)
		{
			handleJoin({ retry: true });
		}
		else if (connectionStatus === FAILED)
		{
			setConfirmDialogState({
				show    : true,
				title   : '混雑しています',
				message : '申し訳ありません。ただいま混み合っておりますので、お時間が経ってから、アクセスしてください'
			});

			retryCount = 0;
			roomIndex = 0;
			setConnectionStatus(IDLE);
		}

		return () =>
		{
		};
	}, [
		room.state,
		roomClient,
		rooms.length,
		settings.relayNum,
		handleJoin,
		connectionStatus,
		rooms
	]);

	// directMode
	useEffect(() =>
	{
		if (location.state?.directMode === true && fetchRoomsComplete)
		{
			handleJoin();
		}

	// eslint-disable-next-line
	}, [ fetchRoomsComplete ]);

	const askForPerms = () =>
	{
		if (mediaPerms.video || mediaPerms.audio)
		{
			navigator.mediaDevices.getUserMedia(mediaPerms);
		}
	};

	const fetchInfos = useCallback(() =>
	{
		firestore.collection('users').where('subdomain', '==', subdomain)
			.get()
			.then((querySnapshot) =>
			{
				querySnapshot.forEach((doc) =>
				{
					if (doc.exists)
					{
						const userData = doc.data();

						setUserOpenTime(userData.openTime ? userData.openTime : '10:00');
						setUserCloseTime(userData.closeTime ? userData.closeTime : '18:00');
						setUserHoliday(userData.holiday ? userData.holiday : [ 0, 0, 0, 0, 0, 0, 0 ]);
						setLogoUrl(userData.logoUrl ? userData.logoUrl : 'images/main_logo.png');
						setGuestInputField1(
							userData.guestInputField1 ? userData.guestInputField1 : { type: 'none', key: '' }
						);
						setGuestInput1(
							userData.guestInputField1?.type ?
								{
									type  : userData.guestInputField1.type,
									key   : userData.guestInputField1.key,
									value : ''
								}
								: { type: 'none', key: '', value: '' }
						);
						setGuestInputField2(
							userData.guestInputField2 ? userData.guestInputField2 : { type: 'none', key: '' }
						);
						setGuestInput2(
							userData.guestInputField2?.type ?
								{
									type  : userData.guestInputField2.type,
									key   : userData.guestInputField2.key,
									value : ''
								}
								: { type: 'none', key: '', value: '' }
						);
						if (userData.nationalHoliday)
						{
							firestore.collection('nationalHolidaysJP').orderBy('createdAt', 'desc')
								.get()
								.then((document) =>
								{
									const nationalHolidaysAr = document.docs[0]?.data()?.holidays;

									if (nationalHolidaysAr)
									{
										setNationalHolidays(
											nationalHolidaysAr.filter(
												(h) => Number(h.type) <= Number(userData.nationalHoliday)
											)
										);
									}
								});
						}
					}
				});

				if (querySnapshot.docs.length === 0)
				{
					setLogoUrl('images/main_logo.png');
				}
			});

	}, []);

	useEffect(() =>
	{
		setAudioMuted(false);
		setVideoMuted(false);
	}, [ setAudioMuted, setVideoMuted ]);

	useEffect(() =>
	{
		roomClient.updateDevices();
	}, [ roomClient ]);

	useEffect(() =>
	{
		askForPerms();
		if (isMobile)
		{
			setVideoResolution('medium');
			setVideoFrameRate(5);
		}
		fetchInfos();

	// eslint-disable-next-line
	}, []);

	/*
	useEffect(() =>
	{
		// ワーストケースのレスポンス対応
		if (connectionStatus === CONNECTING)
		{
			clearTimeout(timer);
			timer = setTimeout(() =>
			{
				timer = null;
				if (connectionStatus !== TALKING)
				{
					roomClient.forceClose();
					setConnectionStatus(FAILED);
				}
			}, 300 * 1000);
		}
	}, [ connectionStatus, roomClient ]);
	*/

	const handleChangeGuestInputField = (e, field) =>
	{

		const newValue = e.target.value;

		if (field === 1)
		{

			setGuestInput1({
				type  : guestInputField1.type,
				key   : guestInputField1.key,
				value : newValue
			});

		}
		else if (field === 2)
		{
			setGuestInput2({
				type  : guestInputField2.type,
				key   : guestInputField2.key,
				value : newValue
			});

		}
	};

	const handleUseCamera = (flag) =>
	{
		setVideoMuted(flag);
	};

	const toggleShowDeviceSettings = () =>
	{
		const newValue = !showDeviceSettings;

		setShowDeviceSettings(newValue);

		setTimeout(() =>
		{
			if (endOfcontentRef.current)
			{
				try
				{
					endOfcontentRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
				}
				catch
				{
				// do nothing
				}
			}
		}, 250);

	};

	const isWorkTime = useMemo(() =>
	{

		const now = dayjs();

		// dayjs => sunday 0 , userHolidy => monday 0
		let wkDay = now.weekday() - 1;

		if (wkDay === -1)
		{
			wkDay = 6;
		}

		// 曜日
		if (userHoliday[wkDay] === 1)
		{
			return false;
		}

		const year = now.year();
		const month = now.month() + 1;
		const date = now.date();

		let isHoliday = false;

		nationalHolidays.forEach((d) =>
		{
			if (year === d.year && month === d.month && date === d.day)
			{
				isHoliday = true;
			}
		});

		if (isHoliday)
		{
			return false;
		}

		const openTimeString = `${year}-${month}-${date} ${userOpenTime}:00`;
		const closeTimeString = `${year}-${month}-${date} ${userCloseTime}:00`;

		const openTimeObj = dayjs(openTimeString);
		const closeTimeObj = dayjs(closeTimeString);

		if (now > openTimeObj && now < closeTimeObj)
		{
			return true;
		}

		return false;
	}, [ userOpenTime, userCloseTime, userHoliday, nationalHolidays ]);

	let roomJoinMarginCSS = '';

	if (!isMobile)
	{
		if (!guestInputField1.key && !guestInputField2.key)
		{
			roomJoinMarginCSS = classes.roomJoinMargin0;
		}
		else if (!guestInputField1.key|| !guestInputField2.key)
		{
			roomJoinMarginCSS = classes.roomJoinMargin1;
		}
	}

	const updateDimensions = useCallback(() =>
	{

		if (!isMobile)
		{
			if (window.innerWidth < 750)
			{
				setUseMobileView({
					view        : true,
					orientation : 'portrait'
				});
				setHideGuestButtomNavi(true);
			}
			else
			{
				setUseMobileView({
					view        : false,
					orientation : ''
				});
				setHideGuestButtomNavi(false);
			}
		}

	}, [ isMobile, setHideGuestButtomNavi, setUseMobileView ]);

	useEffect(() =>
	{
		window.addEventListener('resize', updateDimensions);

		updateDimensions();

		return () => window.removeEventListener('resize', updateDimensions);

	}, [ updateDimensions ]);

	return (
		<>
			<ConfirmDialog
				show={confirmDialogState.show}
				title={confirmDialogState.title}
				message={confirmDialogState.message}
				accept={() => {}}
				cancel={
					location.state?.directMode === true ?
						() => closeConfirmDialog(true)
						: closeConfirmDialog
				}
				closeButtonOnly
			/>
			<MuiThemeProvider theme={theme}>
				{!isMobile && !useMobileView ?
					(
						<div className={classes.root}>
							<div className={classes.mediaSettings}>
								<DeviceSettings volumeCheck/>
							</div>
							<div className={`${classes.roomJoin} ${roomJoinMarginCSS}`}>
								{ room.logoUrl &&
									<img
										alt='logo'
										src={room.logoUrl}
										className={classes.logo}
									/>
								}

								{ (guestInputField1.key ||guestInputField2.key) &&
									<div className={classes.description}>
										<p>通話の前に入力いただきますと、ご相談を円滑に進めることができます。</p>
									</div>
								}
								{ guestInputField1.key &&

									<div className={classes.input}>
										<div className={classes.inputLabel}>{guestInputField1.key}</div>
										<TextField
											id='guestInputField1'
											value={guestInput1.value}
											variant='outlined'
											name='guestInputField1'
											type='text'
											required
											classes={{
												root : classes.inputField
											}}
											onChange={(event) => handleChangeGuestInputField(event, 1)}
										/>
									</div>
								}

								{ guestInputField2.key &&

									<div className={classes.input}>
										<div className={classes.inputLabel}>{guestInputField2.key}</div>
										<TextField
											id='guestInputField2'
											value={guestInput2.value}
											variant='outlined'
											name='guestInputField2'
											type='text'
											required
											classes={{
												root : classes.inputField
											}}
											onChange={(event) => handleChangeGuestInputField(event, 2)}
										/>
									</div>
								}

								<div className={classes.inputCamera}>
									<div className={classes.inputLabel}>カメラを起動しますか？</div>
									<div className={classes.cameraControl}>
										<Button
											className={classnames(
												classes.cameraSwitchBtn,
												!videoMuted ? classes.cameraSwitchBtnActive : null
											)}
											onClick={() => handleUseCamera(false)}
										>
											ON
										</Button>
										<Button
											className={classnames(
												classes.cameraSwitchBtn,
												videoMuted ? classes.cameraSwitchBtnActive : null
											)}
											onClick={() => handleUseCamera(true)}
										>
											OFF
										</Button>
									</div>
								</div>
								<div className={classes.separator} />
								<Button
									className={isWorkTime ? classes.startBtn : classes.startBtnDisabled}
									onClick={() => handleJoin({ retry: false })}
									disabled={!isWorkTime}
								>
									{ isWorkTime ? 'オンライン相談スタート' : '受付時間外です' }
								</Button>
								<div className={classes.terms}>
									<div className={classes.termsLabel}>
										サービス利用規約をご確認の上、スタートボタンを押してください。
									</div>
									<div className={classes.termsBtnWrapper}>
										<Button
											className={classes.termsBtn}
											onClick={() => {}}
										>
											<Link
												to={{ pathname: 'https://www.2nddoorsupport.com/termsofservice' }}
												target='_blank'
												className={classes.termsLink}
											>
												利用規約を表示する
											</Link>
											<ArrowDropDownIcon className={classes.termsIcon} />
										</Button>
									</div>
								</div>
								<div className={classes.warning}>
									<ol>
										<li>通信環境や、非対応ブラウザ・OS などにより接続できない場合は、

											<Link
												to={{ pathname: 'https://www.2nddoorsupport.com/systemrequirements' }}
												target='_blank'
												className={classes.warningLink}
											>
												こちらのページから動作環境
											</Link>

											 をお確かめください。</li>
										<li>途中で接続が切れた場合は同じ担当者とつながらない可能性がございます。</li>
										<li>接続にあたっては、WIFI環境でのご利用を推奨いたします。従量課金制の通信サービスや、
											通信量に上限があるネット回線・プランを利用する場合は通信料にご注意ください。</li>
										<li>本サービスに関連のない質問や、オペレーターが迷惑行為と判断した場合は、
											オペレーター側から通話の遮断、および着信を拒否する場合がございます。</li>
									</ol>
								</div>
							</div>
							{ (location.state?.directMode === true
								|| connectionStatus !== IDLE) &&
								<div className={classes.callingModal}>
									<h2>現在オペレーターにお繋ぎしています。</h2>
									<h2>しばらくお待ちください。</h2>
									<CircularProgress />
								</div>
							}
						</div>
					)
					:
					(
						<div className={`${classes.rootM} ${roomJoinMarginCSS}`}>
							<div className={classes.inputM}>
								<div className={classes.inputLabelM}>カメラを起動しますか？</div>
								<div className={classes.cameraControl}>
									<Button
										className={classnames(
											classes.cameraSwitchBtn,
											!videoMuted ? classes.cameraSwitchBtnActive : null
										)}
										onClick={() => handleUseCamera(false)}
									>
										ON
									</Button>
									<Button
										className={classnames(
											classes.cameraSwitchBtn,
											videoMuted ? classes.cameraSwitchBtnActive : null
										)}
										onClick={() => handleUseCamera(true)}
									>
										OFF
									</Button>
								</div>
							</div>
							<div className={classes.separator} />
							<Button
								className={classes.startBtnM}
								onClick={() => handleJoin({ retry: false })}
								disabled={!isWorkTime}
							>
								{ isWorkTime ? 'オンライン相談スタート' : '受付時間外です' }
							</Button>
							<div className={classes.termsM}>
								<div className={classes.termsLabel}>
									サービス利用規約をご確認の上、<br/>スタートボタンを押してください。
								</div>
								<div className={classes.termsBtnWrapper}>
									<Button
										className={classes.termsBtn}
										onClick={() => {}}
									>
										<Link
											to={{ pathname: 'https://www.2nddoorsupport.com/termsofservice' }}
											target='_blank'
											className={classes.termsLink}
										>
											利用規約を表示する
										</Link>
										<ArrowDropDownIcon className={classes.termsIcon} />
									</Button>
								</div>
							</div>

							<div className={classes.separator} />
							<div className={classes.roomJoinM}>

								{ (guestInputField1.key || guestInputField2.key) &&
									<div className={classes.descriptionM}>
										<p>通話の前に入力いただきますと、ご相談を円滑に進めることができます。</p>
									</div>
								}
								{ guestInputField1.key&&

									<div className={classes.inputM}>
										<div className={classes.guestInputLabelM}>{guestInputField1.key}</div>
										<TextField
											id='guestInputField1'
											value={guestInput1.value}
											variant='outlined'
											name='guestInputField1'
											type='text'
											required
											classes={{
												root : classes.inputField
											}}
											onChange={(event) => handleChangeGuestInputField(event, 1)}
										/>
									</div>
								}

								{guestInputField2.key &&

									<div className={classes.inputM}>
										<div className={classes.guestInputLabelM}>{guestInputField2.key}</div>
										<TextField
											id='guestInputField2'
											value={guestInput2.value}
											variant='outlined'
											name='guestInputField2'
											type='text'
											required
											classes={{
												root : classes.inputField
											}}
											onChange={(event) => handleChangeGuestInputField(event, 2)}
										/>
									</div>
								}

								<div className={classes.warningM}>
									<ol>
										<li>通信環境や、非対応ブラウザ・OS などにより接続できない場合は、
											<Link
												to={{ pathname: 'https://www.2nddoorsupport.com/systemrequirements' }}
												target='_blank'
												className={classes.warningLink}
											>
												こちらのページから動作環境
											</Link>
											 をお確かめください。</li>
										<li>途中で接続が切れた場合は同じ担当者とつながらない可能性がございます。</li>
										<li>接続にあたっては、WIFI環境でのご利用を推奨いたします。従量課金制の通信サービスや、
											通信量に上限があるネット回線・プランを利用する場合は通信料にご注意ください。</li>
										<li>本サービスに関連のない質問や、オペレーターが迷惑行為と判断した場合は、
											オペレーター側から通話の遮断、および着信を拒否する場合がございます。</li>
									</ol>
								</div>
								<div className={classes.separator} />
								<Button
									className={classes.toggleSettingsBtnM}
									onClick={() => toggleShowDeviceSettings()}
								>
									各種設定の変更
									<ArrowDropDownIcon className={classes.termsIcon} />
								</Button>
								{ showDeviceSettings &&
								<div className={classes.mediaSettingsM}>
									<DeviceSettings volumeCheck endOfcontentRef={endOfcontentRef}/>
								</div>
								}
							</div>
							{
								(location.state?.directMode === true
								|| connectionStatus !== IDLE) &&

									<div className={classes.callingModal}>
										<h2>現在オペレーターにお繋ぎしています。</h2>
										<h2>しばらくお待ちください。</h2>
										<CircularProgress />
									</div>

							}
						</div>
					)
				}
			</MuiThemeProvider>
		</>
	);
};

GuestJoinView.propTypes =
{
	room                   : PropTypes.object.isRequired,
	roomClient             : PropTypes.object.isRequired,
	peersLength            : PropTypes.number.isRequired,
	classes                : PropTypes.object.isRequired,
	mediaPerms             : PropTypes.object.isRequired,
	videoMuted             : PropTypes.bool.isRequired,
	setAudioMuted          : PropTypes.func.isRequired,
	setVideoMuted          : PropTypes.func.isRequired,
	setOverRoomLimit       : PropTypes.func.isRequired,
	overRoomLimit          : PropTypes.bool.isRequired,
	rooms                  : PropTypes.array.isRequired,
	settings               : PropTypes.object.isRequired,
	guestInput1            : PropTypes.object.isRequired,
	guestInput2            : PropTypes.object.isRequired,
	setGuestInput1         : PropTypes.func.isRequired,
	setGuestInput2         : PropTypes.func.isRequired,
	setLogoUrl             : PropTypes.func.isRequired,
	isMobile               : PropTypes.bool.isRequired,
	chearChat              : PropTypes.func.isRequired,
	setVideoResolution     : PropTypes.func.isRequired,
	setVideoFrameRate      : PropTypes.func.isRequired,
	fetchRoomsComplete     : PropTypes.bool.isRequired,
	setHideGuestButtomNavi : PropTypes.func.isRequired,
	useMobileView          : PropTypes.bool.isRequired,
	setUseMobileView       : PropTypes.func.isRequired
};

const mapStateToProps = (state) =>
{
	return {
		room          : state.room,
		mediaPerms    : state.settings.mediaPerms,
		peers         : state.peers,
		videoMuted    : state.settings.videoMuted,
		peersLength   : peersLengthSelector(state),
		locale        : state.intl.locale,
		localesList   : state.intl.list,
		overRoomLimit : state.room.overRoomLimit,
		rooms         : state.me.rooms,
		settings      : state.me.settings,
		guestInput1   : state.me.guestInput1,
		guestInput2   : state.me.guestInput2,
		isMobile      : state.me.browser.platform === 'mobile',
		useMobileView : state.me.useMobileView
	};
};

const mapDispatchToProps = (dispatch) =>
{
	return {
		setAudioMuted : (flag) =>
		{
			dispatch(settingsActions.setAudioMuted(flag));
		},
		setVideoMuted : (flag) =>
		{
			dispatch(settingsActions.setVideoMuted(flag));
		},
		setVideoResolution : (resolution) =>
		{
			dispatch(settingsActions.setVideoResolution(resolution));
		},
		setVideoFrameRate : (framerate) =>
		{
			dispatch(settingsActions.setVideoFrameRate(framerate));
		},
		setOverRoomLimit : (flag) =>
		{
			dispatch(roomActions.setOverRoomLimit(flag));
		},
		setGuestInput1 : (guestInput1) =>
		{
			dispatch(meActions.setGuestInput1(guestInput1));
		},
		setGuestInput2 : (guestInput2) =>
		{
			dispatch(meActions.setGuestInput2(guestInput2));
		},
		setLogoUrl : (logoUrl) =>
		{
			dispatch(roomActions.setLogoUrl(logoUrl));
		},
		chearChat : () =>
		{
			dispatch(chatActions.clearChat());
		},
		setHideGuestButtomNavi : (hideGuestBottomNavi) =>
		{
			dispatch(roomActions.setHideGuestButtomNavi(hideGuestBottomNavi));
		},
		setUseMobileView : (useMobileView) =>
		{
			dispatch(meActions.setUseMobileView(useMobileView));
		}
	};
};

export default withRoomContext(connect(
	mapStateToProps,
	mapDispatchToProps,
	null,
	{
		areStatesEqual : (next, prev) =>
		{
			return (
				prev.room === next.room &&
				prev.settings.displayName === next.settings.displayName &&
				prev.settings === next.settings &&
				prev.me.displayNameInProgress === next.me.displayNameInProgress &&
				prev.me.picture === next.me.picture &&
				prev.me.status === next.me.status &&
				prev.intl.locale === next.intl.locale &&
				prev.intl.localesList === next.intl.localesList &&
				prev.peers === next.peers &&
				prev.room.overRoomLimit === next.room.overRoomLimit &&
				prev.room.logoUrl === next.room.logoUrl &&
				prev.me.rooms === next.me.rooms &&
				prev.me.settings === next.me.settings &&
				prev.me.guestInput1 === next.me.guestInput1 &&
				prev.me.guestInput2 === next.me.guestInput2 &&
				prev.me.useMobileView === next.me.useMobileView
			);
		}
	}
)(withStyles(styles)(GuestJoinView)));